module.exports = __webpack_public_path__ + "img/icon_08.15856fd8.svg";